// extracted by mini-css-extract-plugin
export default {"tab-bar":"tabBar_tab-bar__9tY40","item":"tabBar_item__+rrNq","dont-hover":"tabBar_dont-hover__CUCO7","active":"tabBar_active__UCd88"};